export default {
    gestiones: [],
    managementSelected: null,
    usersManagementsRolesFiltered: [],
    usersManagementsRoles: []
}